import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[hsClickStopPropagation]'
})
export class ClickStopPropagationDirective {

  @HostListener('click', ['$event']) onClick(event: Event): void {
    event.stopPropagation();
  }
}
